var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1792 1792",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,-1,113.89831,1277.8305)",
    id: "g3039"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1023,576 h 316 q -1,3 -2.5,8 -1.5,5 -2.5,8 l -212,496 H 414 L 202,592 q -1,-2 -2.5,-8 -1.5,-6 -2.5,-8 h 316 l 95,-192 h 320 z m 513,-30 V 64 Q 1536,38 1517,19 1498,0 1472,0 H 64 Q 38,0 19,19 0,38 0,64 v 482 q 0,62 25,123 l 238,552 q 10,25 36.5,42 26.5,17 52.5,17 h 832 q 26,0 52.5,-17 26.5,-17 36.5,-42 l 238,-552 q 25,-61 25,-123 z",
    id: "path3041",
    fill: "#ffffff",
    transform: "translate(0, -256)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.224d40fcf308788a28dfc293fa0a394b.svg";
export { ForwardRef as ReactComponent };